import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { ApiService } from './api.service';
import { DropdownModel } from '../core';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CarrierService extends ApiService {
  carrier = signal<DropdownModel[] | null>(null);

  constructor(http: HttpClient) {
    super(http, 'Carrier');
  }

  public getDropdownCarrierProductEnrollment() {
    return this.http.options<DropdownModel[]>(`${this.route()}/GetDropdownCarrierProductEnrollment`).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of([]);
        } else {
          throw error;
        }
      })
    );
  }
}
